import { render, staticRenderFns } from "./card_body_assignament.vue?vue&type=template&id=20dc9b72"
import script from "./card_body_assignament.vue?vue&type=script&lang=js"
export * from "./card_body_assignament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports